import React from 'react';

function LocationUser(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M12 2C10.274 2 8.875 3.39899 8.875 5.125C8.875 6.85101 10.274 8.25 12 8.25C9.23899 8.25 7 10.489 7 13.25V15.125L7.00678 15.2174C7.05142 15.5187 7.3112 15.75 7.625 15.75H8.934L9.5031 21.4372C9.53505 21.7567 9.80391 22 10.125 22H13.875L13.9696 21.9929C14.2475 21.9506 14.4681 21.7247 14.4969 21.4372L15.065 15.75H16.375C16.7202 15.75 17 15.4702 17 15.125V13.25C17 10.489 14.761 8.25 12 8.25C13.726 8.25 15.125 6.85101 15.125 5.125C15.125 3.39899 13.726 2 12 2ZM12 3.25C13.0357 3.25 13.875 4.08934 13.875 5.125C13.875 6.16066 13.0357 7 12 7C10.9643 7 10.125 6.16066 10.125 5.125C10.125 4.08934 10.9643 3.25 12 3.25ZM12.1991 9.5052C14.1773 9.60875 15.75 11.2461 15.75 13.25V14.5H14.5L14.4054 14.5071C14.1275 14.5494 13.9069 14.7753 13.8781 15.0628L13.309 20.75H10.69L10.1219 15.0628L10.1054 14.9694C10.0357 14.6971 9.78899 14.5 9.5 14.5H8.25V13.25C8.25 11.1793 9.92934 9.5 12 9.5L12.1991 9.5052Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default LocationUser;
